import { useState } from 'react'
import Box from '@talkdesk/cobalt-react-box'
import Divider from '@talkdesk/cobalt-react-divider'
import Link from '@talkdesk/cobalt-react-link'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTranslation } from 'react-i18next'
import { INVALID_CREDENTIALS_HELP } from '../../constants/links'
import redirect from '../../utils/redirect'
import LoginWithContext from '../Login'
import IdentityProviders from '../../components/IdentityProviders'
import ErrorMessage from '../../components/ErrorMessage'

const LoginBody = ({
  brandAssetsURL,
  brandingSettings,
  localLoginEnabled,
  csrf,
  showCaptcha,
  siteKey,
  email,
  identityProviders,
  hasIdentityProviders,
}) => {
  const { t } = useTranslation()
  const [showError, setShowError] = useState(false)
  const [identityProvidersDisabled, setIdentityProvidersDisabled] =
    useState(false)

  const handleErrorChange = () => setShowError(true)

  const shouldShowError = () =>
    showError || new URLSearchParams(window.location.search).has('error')

  const errorMessage = (
    <Link href={INVALID_CREDENTIALS_HELP(brandingSettings)}>
      {t('login.invalidCredentialsAction')}
    </Link>
  )

  const displayError = shouldShowError()

  return (
    <>
      {displayError ? (
        <ErrorMessage
          title={t('login.invalidCredentialsTitle')}
          message={errorMessage}
        />
      ) : null}
      {localLoginEnabled ? (
        <LoginWithContext
          csrf={csrf}
          showCaptcha={showCaptcha}
          siteKey={siteKey}
          email={email}
          redirect={redirect}
          handleErrorChange={handleErrorChange}
          setIdentityProvidersDisabled={setIdentityProvidersDisabled}
        />
      ) : null}
      {hasIdentityProviders && localLoginEnabled && (
        <Box paddingY={6}>
          <Divider>
            <Box as='span' paddingX={2}>
              <Text inline>{t('login.or')}</Text>
            </Box>
          </Divider>
        </Box>
      )}
      {hasIdentityProviders && (
        <IdentityProviders
          identityProviders={identityProviders}
          brandAssetsURL={brandAssetsURL}
          disabled={identityProvidersDisabled}
        />
      )}
    </>
  )
}

export default LoginBody
